import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Form } from "react-bootstrap";
import Select from "react-select";

import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// CommonDatePickerForFilter
import {
  GetAccessoryListingFilterData,
  GetAccessoryTypeFilterData,
} from "../../../../common/helper/BasicFn";
import { CallPOSTAPI, CallGETAPI } from "../../../../common/services";
import {
  addFilterData,
  addPayloadData,
  updateFilterData,
  removeFilterData,
  removePayloadData,
} from "../../../../store/slices/AccessoryListingFilterSlice";
import CommonDatePickerForFilter from "../../../../common/components/DatePickers/CommonDatePickerForFilter";
import PaginateAutoComplete from "../../../../common/components/custom-ui/PaginateAutoComplete";
import { prepareAedBrandModelOptions, printConsole } from "../../../../common/helper/Common";
import CustomAEDBrandModalMultiDropdown from "../../../../common/components/custom-ui/CustomAEDBrandModalMultiDropdown";
import GlobalMultiDropdown from "../../../../common/components/custom-ui/GlobalMultiDropdown";

export default function AccessoryListingFilter({
  setOpen,
  setAedList,
  setShowLoading,
  search,
  setTotalPage,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [accessoryBrandModelList, setAccessoryBrandModelList] = useState([]);
  const [accessoryTypeList, setAccessoryTypeList] = useState([]);
  const [expirationRangeType, setExpirationRangeType] = useState([
    { label: "30 Days", value: 30 },
    { label: "60 Days", value: 60 },
    { label: "90 Days", value: 90 },
    { label: "Expired", value: 0 },
  ]);
  const [formData, setFormData] = useState({
    account_name: [],
    accessory_brand_model: [],
    accessory_type: [],
    expiration_range_type: [],
    expiration_date_range1: "",
    expiration_date_range2: "",
    sites: [],
    state: [],
  });

  const accessoryFilterData = useSelector(
    (state) => state.accessorylistingfilter.accessoryListingFilterData
  );

  const handleDateChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // drawer header
  const DrawerHeader = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: "space-between",
  }));

  // close drawer function
  const handleDrawerClose = () => {
    setOpen(false);
  };

  // handle select change
  const handleSelectChange = (data, key) => {
    let valueArray = [];
    data.map((item, index) => {
      valueArray.push({
        label: item.label,
        value: item.value,
      });
    });
    setFormData((old) => ({ ...old, [key]: valueArray }));
  };

  const handleSelectRangeTypeChange = (data) => {
    setFormData((oldFormData) => ({
      ...oldFormData,
      expiration_range_type: data,
    }));
  };

  // handle select change
  const handleSelectSubmitData = (data) => {
    printConsole({ data: data })  // print console.log
    let valueArray = [];
    data.map((item) => {
      valueArray.push(item.value);
    });
    printConsole("Selected Data by handle submit", valueArray) // print console.log
    return valueArray;
  };

  const handleSearchSelectSubmitData = (data, valueKey = "value") => {
    let valueArray = [];
    printConsole({ data }); // print console.log
    data.map((item) => {
      valueArray.push(item?.value);
    });
    return valueArray;
  };

  // handle radio buttons change
  const handleRadioChange = (value, key) => {
    setFormData((old) => ({ ...old, [key]: value }));
  };

  // prepare options
  const prepareOptions = (optionsData, key, value) => {
    if (optionsData) {
      let allData = [];
      for (let i = 0; i < optionsData.length; i++) {
        let singleData = {};
        singleData.value = optionsData[i][key];
        singleData.label = optionsData[i][value];
        allData.push(singleData);
      }
      allData.sort((a, b) => a.label.localeCompare(b.label));
      return allData;
    }
  };

  const prepareOptionsForAccessoryType = (optionsData) => {
    if (optionsData) {
      let allData = [];
      for (let i = 0; i < optionsData.length; i++) {
        let singleData = {};
        singleData.value = optionsData[i];
        singleData.label = optionsData[i];
        allData.push(singleData);
      }
      allData.sort((a, b) => a.label.localeCompare(b.label));
      return allData;
    }
  };

  const prepareBrandModelOptions = (data) => {
    if (!data) return [];

    const options = [];
    const brandOptions = {};

    for (const item of data) {
      const brandName = item.brand_name;
      if (!brandOptions[brandName]) {
        brandOptions[brandName] = {
          label: brandName,
          options: [],
        };
        options.push(brandOptions[brandName]);
      }
      item?.data?.map((subitem) => {
        brandOptions[brandName].options.push({
          value: subitem.model_id,
          label: subitem.model_name,
        });
      });
    }

    return options;
  };

  // fetchOnLoad
  const fetchOnLoad = async () => {
    let result = await GetAccessoryTypeFilterData();

    if (result.status) {
      // accountList
      // let accountListData = result?.data?.accountlist;
      // let allAccountListData = prepareOptions(
      //   accountListData,
      //   "account_id",
      //   "account_name"
      // );
      // setAccountList(allAccountListData);

      //aedBrandModel
      // let accessoryBrandModelListData = result?.data?.AccessoryBrandModel;
      // const options = prepareBrandModelOptions(accessoryBrandModelListData);
      // setAccessoryBrandModelList(options);

      // accessoryTypeList
      let accessoryTypeListData = result?.data?.AccessoryType;
      let allAccessoryTypeListData = prepareOptionsForAccessoryType(
        accessoryTypeListData
      );
      setAccessoryTypeList(allAccessoryTypeListData);

      // stateList
      // let stateListData = result?.data?.StateList;
      // let allstateListData = prepareOptions(
      //   stateListData,
      //   "state_id",
      //   "state_name"
      // );
      // setStateList(allstateListData);

      //Sites
      // let sitesData = result?.data?.SiteList;
      // let allSitesData = prepareOptions(
      //   sitesData,
      //   "account_site_info_id",
      //   "account_site_name"
      // );
      // setSitesList(allSitesData);
    }
  };

  // clear filter
  const handleClearFilter = async (e) => {
    e.preventDefault();
    setShowLoading(true);
    setFormData((old) => ({
      ...old,
      account_name: [],
      accessory_brand_model: [],
      accessory_type: [],
      expiration_range_type: [],
      expiration_date_range1: "",
      expiration_date_range2: "",
      sites: [],
      state: [],
    }));
    dispatch(removeFilterData());
    dispatch(removePayloadData());

    const result = await CallPOSTAPI("acc/accessory-listing", {
      page: 1,
      search: search.trimEnd(),
    });
    if (result?.data?.status) {
      const aeds = result?.data?.data;
      setAedList(aeds?.accList);
      setTotalPage(aeds?.totalPages);
    }

    handleDrawerClose();
    setShowLoading(false);
  };

  const stringifyArrays = (data) => {
    const stringifiedData = {};
    for (const key in data) {
      if (Array.isArray(data[key])) {
        stringifiedData[key] = data[key].join(",");
      } else {
        stringifiedData[key] = data[key];
      }
    }
    return stringifiedData;
  };

  const handleSubmit = async (e) => {

    handleDrawerClose();

    const payloadData = {
      account_name:
        formData?.account_name?.length > 0
          ? handleSelectSubmitData(formData?.account_name)
          : [],
      site_name:
        formData?.sites?.length > 0
          ? handleSelectSubmitData(formData?.sites)
          : [],
      state:
        formData?.state?.length > 0
          ? handleSelectSubmitData(formData?.state)
          : [],
      accessory_brand_model:
        formData?.accessory_brand_model?.length > 0
          ? handleSearchSelectSubmitData(formData?.accessory_brand_model, "model_id")
          : [],
      accessory_type:
        formData?.accessory_type?.length > 0
          ? handleSelectSubmitData(formData?.accessory_type)
          : [],
      from: formData?.expiration_date_range1,
      to: formData?.expiration_date_range2,
      expirationrange: formData?.expiration_range_type?.value,
    };


    const payloadDataStringified = stringifyArrays(payloadData);

    const allFieldsEmpty = Object.entries(formData).map(([key, value]) => {
      return value?.length !== 0 && value !== undefined;
    });

    let isTrue = false;
    for (const item of allFieldsEmpty) {
      if (item === false) {
        printConsole("item", item) // print console.log
        isTrue = true;
        handleDrawerClose();
        break;
      }
    }
    printConsole({ isTrue: isTrue }) // print console.log
    setShowLoading(true);
    if (isTrue) {
      printConsole({ isTrue1: isTrue }) // print console.log
      if (
        accessoryFilterData &&
        Object.keys(accessoryFilterData).length !== 0
      ) {
        dispatch(updateFilterData(formData));
      } else {
        dispatch(addFilterData(formData));
      }

      const results = await CallPOSTAPI("acc/accessorylisting-search", {
        ...payloadDataStringified,
        page: 1,
        search: search,
      });

      if (results?.data?.status) {

        setAedList(results?.data?.data?.accList);
        dispatch(addPayloadData(payloadDataStringified));
      }

    }
    setShowLoading(false);
  };

  useEffect(() => {
    fetchOnLoad();

    if (accessoryFilterData && Object.keys(accessoryFilterData).length !== 0) {
      setFormData({
        account_name: accessoryFilterData?.account_name,
        accessory_brand_model: accessoryFilterData?.accessory_brand_model,
        accessory_type: accessoryFilterData?.accessory_type,
        expiration_range_type: accessoryFilterData?.expiration_range_type,
        expiration_date_range1: accessoryFilterData?.expiration_date_range1,
        expiration_date_range2: accessoryFilterData?.expiration_date_range2,
        sites: accessoryFilterData?.sites,
        state: accessoryFilterData?.state,
      });
    }
  }, []);
  const handleSearchSelectChange = (data, key, idKey, valueKey) => {
    printConsole("Selected Data1", data) // print console.log
    printConsole("Selected Data2", key) // print console.log
    printConsole("Selected Data3", idKey) // print console.log
    printConsole("Selected Data4", valueKey) // print console.log
    let valueArray = [];
    data.forEach((item) => {
      valueArray.push({
        label: item?.[valueKey],
        value: item?.[idKey],
      });
    });
    printConsole("Selected Data12344", valueArray) // print console.log
    setFormData((old) => ({ ...old, [key]: valueArray }));
  };
  return (
    <div style={{ background: "#000" }}>
      {/* drawer header */}
      <DrawerHeader>
        <div className="left-btns">
          <IconButton onClick={handleDrawerClose}>
            <ChevronRightIcon />
          </IconButton>
        </div>
      </DrawerHeader>
      {/* main content of filter */}
      <div className="content px-4">
        {/* Account Name */}
        <Form.Group className="mb-3">
          <Form.Label>Account Name</Form.Label>
          <PaginateAutoComplete
            dropDownName={"account_name"}
            // apiEndpoint={"account/account-list-dropdown"}
            apiEndpoint={'acc/accessory-accountlist-fetch'}
            idKey={"account_id"}
            valueKey={"account_name"}
            parentKey={"accountlist"}
            onSelect={(e, value) => {
              handleSearchSelectChange(value, "account_name", "account_id", "account_name");
            }}
            shouldFetchOnOpen={true}
            isCache={false}
            className={"react-select-container"}
            selectDisabled={false}
            closeMenuSelect={false}
            multiple={true}
            showCheckBox={true}
            showCountsOnly={1}
            defaultValue={
              formData?.account_name?.length > 0 ? formData.account_name?.map((it => ({
                account_id: it.value,
                account_name: it.label,
              }))) : null
            }
          />
        </Form.Group>

        {/* Accessory Brand/Model */}
        <Form.Group className="mb-3">
          <Form.Label>Accessory Brand/Model</Form.Label>

          <CustomAEDBrandModalMultiDropdown
            dropDownName={"accessory_brand_model"}
            apiEndpoint={"acc/accessory-brandmodel-fetch"}
            idKey={"model_id"}
            valueKey={"model_name"}
            parentKey={"AccessoryBrandModel"}
            showSelectedCount={true}
            onSelect={(e) => {
              const resultData = e.map((it => ({ value: it?.model_id, label: it?.model_name })))
              handleSelectChange(resultData, "accessory_brand_model");
            }}
            shouldFetchOnOpen={true}
            isCache={false}
            className={"react-select-container custom-select"}
            selectDisabled={false}
            isMultiSelect={true}
            closeMenuSelect={false}
            prepareOptions={prepareAedBrandModelOptions}
            initialSelectedValue={formData?.accessory_brand_model?.map((it => ({ model_id: it?.value, model_name: it?.label }))) || []}
          />
        </Form.Group>

        {/* Accessory Type */}
        <Form.Group className="mb-3">
          <Form.Label>Accessory Type</Form.Label>
          {/* /acc/accessory-type-fetch */}
          <GlobalMultiDropdown
            dropDownName={"accessory_type"}
            apiEndpoint={"acc/accessory-type-fetch"}
            idKey={"value"}
            valueKey={"title"}
            parentKey={""}
            onSelect={(data) => {
              handleSelectChange(data, "accessory_type");
            }}
            shouldFetchOnOpen={true}
            isCache={false}
            className={"react-select-container custom-select"}
            selectDisabled={false}
            isMultiSelect={true}
            closeMenuSelect={false}
            initialSelectedValue={
              formData?.accessory_type?.length > 0 ? formData?.accessory_type.map((it) => ({ ...it, value: it.value, title: it.label })) : []
            }
          />
          {/* <Select
            isMulti
            menuPosition="fixed"
            className="react-select-container custom-select"
            name="accessory_type"
            options={accessoryTypeList}
            value={formData.accessory_type}
            onChange={(data) => {
              handleSelectChange(data, "accessory_type");
            }}
          /> */}
        </Form.Group>

        {/* Expiration Range Type */}
        <Form.Group className="mb-3">
          <Form.Label>Expiration Range Type</Form.Label>
          <Select
            className="react-select-container"
            options={expirationRangeType}
            value={formData?.expiration_range_type}
            onChange={(data) => {
              handleSelectRangeTypeChange(data);
            }}
            menuPosition="fixed"
          />
        </Form.Group>

        {/* Expiration Date Range */}
        <Form.Group className="mb-3">
          <Form.Label>Expiration Date Range</Form.Label>
          <div className="d-flex">
            {" "}
            <CommonDatePickerForFilter
              calName="expiration_date_range1"
              CalVal={formData.expiration_date_range1}
              HandleChange={handleDateChange}
            />
            <CommonDatePickerForFilter
              calName="expiration_date_range2"
              CalVal={formData.expiration_date_range2}
              HandleChange={handleDateChange}
              minDate={
                formData.expiration_date_range1
                  ? new Date(formData.expiration_date_range1)
                  : null
              }
              disabled={!formData.expiration_date_range1}
            />
          </div>
        </Form.Group>

        {/* Sites */}
        <Form.Group className="mb-3">
          <Form.Label>Sites</Form.Label>
          <PaginateAutoComplete
            dropDownName={"sites"}
            apiEndpoint={"acc/accessory-sitelist-fetch"}
            idKey={"account_site_info_id"}
            valueKey={"account_site_name"}
            parentKey={"SiteList"}
            showCountsOnly={1}
            onSelect={(e, value) => {
              handleSearchSelectChange(value, "sites", "account_site_info_id", "account_site_name");
            }}
            shouldFetchOnOpen={true}
            isCache={false}
            className={"react-select-container"}
            selectDisabled={false}
            closeMenuSelect={false}
            multiple={true}
            showCheckBox={true}
            defaultValue={
              formData?.sites?.length > 0 ? formData.sites.map(it => ({
                account_site_info_id: it.value,
                account_site_name: it.label,
              })) : null
            }
          />
        </Form.Group>

        {/* State */}
        <Form.Group className="mb-3">
          <Form.Label>State</Form.Label>
          <PaginateAutoComplete
            dropDownName={"state"}
            apiEndpoint={"acc/accessory-state-fetch"}
            idKey={"state_id"}
            valueKey={"state_name"}
            parentKey={"StateList"}
            showCountsOnly={1}
            onSelect={(e, value) => {
              handleSearchSelectChange(value, "state", 'state_id', 'state_name');
            }}
            shouldFetchOnOpen={true}
            isCache={false}
            className={"react-select-container"}
            selectDisabled={false}
            closeMenuSelect={false}
            multiple={true}
            showCheckBox={true}
            // defaultValue={
            //   formData?.state?.length > 0 ? formData.state : null
            // }

            defaultValue={
              formData?.state?.length > 0 ? formData.state.map(it => ({
                state_id: it.value,
                state_name: it.label,
              })) : null
            }

          />
        </Form.Group>

        {/* submit buttons */}
        <div className="mt-4 pb-2 btn-align">
          <button
            className="btn btn-light btn-clear-filter"
            onClick={(e) => {
              handleClearFilter(e);
            }}
          >
            Clear
          </button>
          <button
            className="btn btn-light ms-2 btn-submit-filter"
            style={{
              backgroundColor: "#4fe14fe6",
              color: "#FFF",
              border: "none",
            }}
            type="button"
            onClick={(e) => {
              handleSubmit(e);
            }}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
}
